import React, { useRef, useState, useEffect } from "react";
import gatewaysGroup from "./Menu/HeaderGateways.mock.json";
import { LOCAL_STORAGE_KEY_PREFERRED_GATEWAY } from "../../../const/const";
import { RCL, RCL as useTranslation } from "../../RCL";
import { setBookingSearchBox } from "../BookingSearchBox";
import { HeaderGatewayMenu } from "./Menu";
import * as styles from "./HeaderGateway.module.scss";

const HeaderGateway = () => {
	const gatewaySwitcherButtonRef = useRef(null);
	const [isMenuOpened, setIsMenuOpened] = useState(false);
	const [currentGateway, setCurrentGateway] = useState({
		label: "Toronto",
		value: "YYZ",
	});

	const handleChangeGateway = gateway => {
		localStorage.setItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY, JSON.stringify(gateway));
		// Set default gateway (temporary) in the booking search box
		// (localStorage above is picked up and used later)
		setBookingSearchBox({
			from: gateway.value,
			force: true,
		});
		setCurrentGateway(gateway);
	};

	const handleGatewayMenu = open => {
		setIsMenuOpened(open);

		// On close Gateway menu, set focus back to gateway switcher button
		if (!open && gatewaySwitcherButtonRef.current) {
			setTimeout(() => {
				gatewaySwitcherButtonRef.current.focus();
			}, 0);
		}
	};

	useEffect(() => {
		let defaultGateway = { label: "Toronto", value: "YYZ" };

		try {
			const storedGateway = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY));
			if (storedGateway) {
				const foundGateway = gatewaysGroup.find(group =>
					group.gateways.some(gateway => gateway.value === storedGateway.value)
				);

				if (foundGateway) {
					defaultGateway = storedGateway;
				}
			}
		} catch (err) {
			console.error(err);
		}

		setCurrentGateway(defaultGateway);
	}, []);

	return (
		<>
			<div className={styles.gatewaySwitcher}>
				{currentGateway.label}
				<button
					type="button"
					className={styles.gatewaySwitcherButton}
					onClick={() => handleGatewayMenu(true)}
					aria-label={useTranslation({ searchKey: "a11y-open-menu" })}
					aria-expanded={isMenuOpened}
					aria-controls="main-menu-gateway-nav"
					ref={gatewaySwitcherButtonRef}>
					<RCL searchKey="change-gateway" />
				</button>
			</div>
			<HeaderGatewayMenu
				id="main-menu-gateway-nav"
				isOpened={isMenuOpened}
				gatewaysGroup={gatewaysGroup}
				currentGateway={currentGateway}
				handleChangeGateway={handleChangeGateway}
				handleGatewayMenu={handleGatewayMenu}
			/>
		</>
	);
};

export default HeaderGateway;
export { HeaderGateway };
